{
  "comment": "M7 spec §8 (S21 owns the paths and the ladder; S25 the stipend and the epilogue): every effect goes through sim pressure, votes and floors, never forceRelation. Durations count online faction days; a floor or grievance due offline is extended until the player has been online floorExtensionOnlineDays days. ladder: every allowed move (rev 3: Blackmail → Expose, Guardians or Sell; Expose and Guardians both ways); anything else is a typed refusal. The Tethys → player pressure seed, the stipend share, the Candle-dark delay and the Meridian payout are not in the spec: placeholders. Placeholders for the balance pass (M7 spec §15 item 4); tune freely. S21 additions: expose.fallbackSponsor sponsors the vote after Guardians → Expose without a player corporation (Kell's leak through the Mutual); guardians.wantedBounty is the Authority bounty seeded on joining (≥ law.json wanted level 2), tethysPressureSeed the Tethys → player seed when the path lands retaliation, tethysSecurityPressure the Tethys → guardian seed (the security response in vein systems), hiddenTransfer the Holdfast's funding of the cell; sell.tethysPressureSeed applies only after Blackmail → Sell. All placeholders. S25 additions: blackmail.stipend* pays the stipend each online day while Blackmail is in force (base / stipendIncomeDays × share × the stability factor: 1 at stipendFullAtStability, 0 at stipendZeroAtStability, 0 with the gate closed); candleDark is the hidden event candleDarkOnlineDays after the Blackmail commit; rollCall.kellTrust sums flag weights into Kell's trust; payroll is the \"on the payroll\" Wire note; epilogue.items holds the Wire epilogue lines per item kind and variant (tokens {for} {against}), bannedWords the celebratory words the epilogue never uses; repeatables are the post-finale repeat offers per path; corpBallot the player corporation's default stance per path (ban, repeal). All text placeholders until the naming and voice pass.",
  "expose": {
    "tethysPressureSeed": 40,
    "reopenCooldownDays": 20,
    "repealAfterOnlineDays": 30,
    "fallbackSponsor": "mutual"
  },
  "blackmail": {
    "stipendShare": 0.05,
    "clawbackCycles": 2,
    "candleDarkOnlineDays": 10,
    "stipendIncomeDays": 10,
    "stipendFullAtStability": 70,
    "stipendZeroAtStability": 10,
    "candleDark": {
      "headline": "Candle relay: no transmission since its last count.",
      "severity": 1,
      "source": "mutualBulletin"
    }
  },
  "guardians": {
    "aggressionFloor": 70,
    "floorOnlineDays": 20,
    "floorAfterBlackmailOnlineDays": 15,
    "wantedBounty": 10000,
    "tethysPressureSeed": 30,
    "tethysSecurityPressure": 40,
    "hiddenTransfer": {
      "from": "holdfast",
      "amount": 20000
    }
  },
  "sell": {
    "meridianTethysPressure": 60,
    "grievanceFloor": 40,
    "grievanceOnlineDays": 30,
    "payout": 150000,
    "payoutAfterBlackmailMult": 0.6,
    "tethysPressureSeed": 30
  },
  "floorExtensionOnlineDays": 3,
  "ladder": [
    {
      "from": "blackmail",
      "to": "expose"
    },
    {
      "from": "blackmail",
      "to": "guardians"
    },
    {
      "from": "blackmail",
      "to": "sell"
    },
    {
      "from": "expose",
      "to": "guardians"
    },
    {
      "from": "guardians",
      "to": "expose"
    }
  ],
  "epilogue": {
    "days": 10,
    "minItems": 4,
    "maxItems": 6,
    "bannedWords": [
      "victory",
      "triumph",
      "hero",
      "heroes",
      "heroic",
      "celebrate",
      "celebrates",
      "celebration",
      "cheer",
      "cheers",
      "saved",
      "justice",
      "won",
      "wins",
      "glory",
      "finally"
    ],
    "items": {
      "path": {
        "expose": {
          "headline": "Charter Hub hearing enters a bundle of First Rush records. The clerk reads the dates aloud.",
          "source": "authorityGazette",
          "severity": 2
        },
        "blackmail": {
          "headline": "Tethys lists a new independent consultant. Fee undisclosed.",
          "source": "tethysComms",
          "severity": 1
        },
        "guardians": {
          "headline": "A new hull flies with the cell. The Watch book has a new hand in it.",
          "source": "candleRelay",
          "severity": 2
        },
        "sell": {
          "headline": "Meridian Counsel files against Tethys. The file it cites was bought, not found.",
          "source": "mutualBulletin",
          "severity": 2
        }
      },
      "broken": {
        "expose": {
          "headline": "Maren Voss retires from Tethys on full pension. The board thanks her for fifty years of service.",
          "source": "tethysComms",
          "severity": 1
        },
        "blackmail": {
          "headline": "Carrow Refinery posts another three-shift week. Fracture output steady.",
          "source": "tethysComms",
          "severity": 1
        },
        "guardians": {
          "headline": "Charter Office adds a raider to the wanted list. Same paint as the rest of them.",
          "source": "authorityGazette",
          "severity": 1
        },
        "sell": {
          "headline": "Meridian bids for Tethys fracture leases. The rigs keep the same crews and get new paint.",
          "source": "mutualBulletin",
          "severity": 1
        }
      },
      "stability": {
        "normal": {
          "headline": "Gate traffic runs to schedule. Gate Control reports no holds this week.",
          "source": "authorityGazette",
          "severity": 1
        },
        "flickers": {
          "headline": "Gate held twice this week. Outbound order at release unchanged.",
          "source": "mutualBulletin",
          "severity": 1
        },
        "tremors": {
          "headline": "Gate holds past six hours, three days running. Filters up again at the Hub.",
          "source": "mutualBulletin",
          "severity": 2
        },
        "closed": {
          "headline": "The gate is shut. Ours were already on reserve air. We note it.",
          "source": "candleRelay",
          "severity": 3
        }
      },
      "vote": {
        "pending": {
          "headline": "Tetherstone ban: ballots still out. The Authority's chair holds the tie-break.",
          "source": "authorityGazette",
          "severity": 1
        },
        "passed": {
          "headline": "Tetherstone ban carried, {for} to {against}. Tethys says it will appeal.",
          "source": "authorityGazette",
          "severity": 2
        },
        "failed": {
          "headline": "Tetherstone ban falls, {for} to {against}. The measure can return after the cooling period.",
          "source": "authorityGazette",
          "severity": 2
        }
      },
      "okafor": {
        "aboard": {
          "headline": "A retired surveyor gives his name to the record. He asks that it be spelled right.",
          "source": "mutualBulletin",
          "severity": 1
        },
        "safe": {
          "headline": "Dr Idris Okafor, formerly of Tethys Survey, declines to comment. He has a relay to keep.",
          "source": "mutualBulletin",
          "severity": 1
        },
        "held": {
          "headline": "Tethys Security confirms a former employee is assisting with an internal review.",
          "source": "tethysComms",
          "severity": 1
        },
        "absent": {
          "headline": "The survey that said the gate ran on a cycle is still on file. Nobody has withdrawn it.",
          "source": "mutualBulletin",
          "severity": 1
        }
      },
      "reyes": {
        "ally": {
          "headline": "The Watch book adds a line: one more name that didn't lift today.",
          "source": "candleRelay",
          "severity": 1
        },
        "cool": {
          "headline": "The Watch book adds a line. The relay doesn't say who wrote it.",
          "source": "candleRelay",
          "severity": 1
        },
        "hostile": {
          "headline": "Guardian raider still hunting an independent pilot, Patrol says. Pilot not named.",
          "source": "authorityGazette",
          "severity": 1
        },
        "dead": {
          "headline": "The Watch book changes hands. The new hand writes smaller.",
          "source": "candleRelay",
          "severity": 1
        }
      },
      "hale": {
        "voided": {
          "headline": "Charter Office reopens charters granted under an unrecorded arrangement. The Commissioner was unavailable.",
          "source": "authorityGazette",
          "severity": 2
        },
        "deal": {
          "headline": "Holdfast generational claims entered in the Charter registry. Taxable from next quarter.",
          "source": "authorityGazette",
          "severity": 1
        },
        "refused": {
          "headline": "Commissioner Hale signs the archive retention log again. His initials, ten years on.",
          "source": "mutualBulletin",
          "severity": 1
        }
      },
      "claims": {
        "corp": {
          "headline": "Your corporation files its quarterly return on time. Tetherstone line: see attached.",
          "source": "authorityGazette",
          "severity": 1
        },
        "pilot": {
          "headline": "Independent pilot's account current. One more hull in the queue.",
          "source": "mutualBulletin",
          "severity": 1
        }
      }
    }
  },
  "rollCall": {
    "kellTrust": {
      "weights": {
        "watchers_helped": 2,
        "watchers_betrayed": -3,
        "manifest_sold": -1,
        "hale_deal": -1,
        "hale_refused": 1,
        "okafor_warned": 1,
        "claim_assisted_2": 1,
        "claim_assisted_3": 1,
        "claim_assisted_4": 1,
        "claim_assisted_5": 1
      },
      "perHoldfastContract": 0.5,
      "highAt": 3,
      "lowAt": -1
    }
  },
  "payroll": {
    "headline": "Tethys adds an independent hauler to its preferred contractor list. Terms private.",
    "source": "tethysComms",
    "severity": 1
  },
  "repeatables": [
    {
      "id": "guardian_raid",
      "paths": [
        "guardians"
      ],
      "giver": "guardian",
      "contractType": "clearRaiders",
      "everyOnlineDays": 3,
      "firstStoryShip": "lesseeBarge"
    },
    {
      "id": "meridian_contract",
      "paths": [
        "sell"
      ],
      "giver": "meridian",
      "contractType": "courier",
      "everyOnlineDays": 3
    },
    {
      "id": "voss_stipend",
      "paths": [
        "blackmail"
      ],
      "giver": "tethys",
      "everyOnlineDays": 1
    },
    {
      "id": "tethys_repo_hunt",
      "paths": [
        "expose",
        "guardians"
      ],
      "giver": "tethys",
      "everyOnlineDays": 5,
      "needsRetaliation": true
    },
    {
      "id": "ban_seizure",
      "paths": [
        "expose"
      ],
      "giver": "authority",
      "contractType": "recovery",
      "everyOnlineDays": 4,
      "needsFlags": [
        "ban_passed"
      ]
    },
    {
      "id": "ban_fence",
      "paths": [
        "expose",
        "guardians"
      ],
      "giver": "raider",
      "contractType": "delivery",
      "everyOnlineDays": 4,
      "needsFlags": [
        "ban_passed"
      ]
    }
  ],
  "corpBallot": {
    "expose": {
      "ban": "for",
      "repeal": "against"
    },
    "guardians": {
      "ban": "for",
      "repeal": "against"
    },
    "blackmail": {
      "ban": "abstain",
      "repeal": "abstain"
    },
    "sell": {
      "ban": "abstain",
      "repeal": "abstain"
    }
  }
}
